import { t } from "@/context/language";
import { ComparisonSection } from "@/pages/seoLanding/components/comparisonSection";

/** Compara a rotina de cobrança manual com a automação da Fidexa. */
export const ManualVsAutomation = () => {
  const copy = t.manualVsAutomation;

  return (
    <ComparisonSection
      id="manual-ou-automacao"
      title={copy.title}
      caption={copy.caption}
      columns={copy.columns}
      rows={copy.rows}
    />
  );
};
